export default {
    'hallh.loading': '加载中',
    'hallh.primary.title': '初级场',
    'hallh.middle.title': '中级场',
    'hallh.high.title': '高级场',
    'hallh.top.title': '精英场',
    'hallh.level.describe': '场次条件',
    'hallh.coin.not': '金币不足',
    'hallh.setting.title': '设置',
};